import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue';
interface IProps {
    modelValue?: any;
    label?: string;
    disabled?: boolean;
    color?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSwich',
  props: {
    modelValue: null,
    label: null,
    disabled: { type: Boolean },
    color: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
    modelValue?: any;
    label?: string;
    disabled?: boolean;
    color?: string;
};

const model = ref<boolean>(false);



watch(() => props.modelValue, () => { if (props.modelValue != model.value) model.value = props.modelValue })


watch(() => model.value,
    () => {
        emit('update:modelValue', model.value);
    });

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createBlock(_component_v_switch, {
    label: props.label,
    disabled: props.disabled,
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    color: props.color
  }, null, 8, ["label", "disabled", "modelValue", "color"]))
}
}

})